<template>
  <div class="fill-in-blank">
    <h5 v-html="(active+1) +'.'+ data[active].examCont +'（'+ data[active].scores+'分）' "> </h5>
    <van-icon v-if="isdd && isdd !=null" color="red" name="success" /> <van-icon v-if="!isdd && isdd !=null" color="red" name="cross" />
    <span>&nbsp;&nbsp;依次在下框中输入答案：</span>
    <van-cell-group>
    <div v-for="(item, i) in data[active].examan" :key="i">
      <van-field v-model="data[active].examansws[i]" autosize placeholder="请输入答案" />
    </div>
    </van-cell-group>
    <!--正确答案题目解析-->
    <div style="padding: .625rem;"> <van-button type="warning" @click="ctrk(data[active].examInfoId)" v-if="!isdd && isdd !=null">收入错题库</van-button></div>
    <div  @click="checkda(data[active].examan,data[active].examansws,data[active].examTypeId,data[active])" v-if="!isda" style="padding: .625rem;">查看正确答案</div>
    <div v-if="isda"  style="height: 100px;width: 100%;padding: .625rem;"  >正确答案：<a v-for="(a,x) in data[active].examan" v-html="x<data[active].examan.length-1?a.optioncontent+',':a.optioncontent"></a> </div>
    <div v-if="isda" style="height: 100px;width: 100%;padding: .625rem;"  >题目解析：<a v-html="data[active].gradestand"></a> </div>
    <div style="height: 100px;width: 100%" ></div>
  </div>
</template>
<script>
import {Notify} from "vant";

export default {
  props: {
    data: {
      type: Array,
      default: () => []
    },
    active: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      activeIndex: 0,
      isda:false,
      isdd:null,
    }
  },
  methods: {
    changisda()
    {
      this.isda = false;
      this.isdd = null;
    },
    checkda(zqdan,dtdan,typeid,item)
    {
      if(dtdan != '' && dtdan!=null)
      {
        let isd = 0
        for (let i = 0; i < zqdan.length; i++) {
          for (let j = 0; j < dtdan.length; j++) {
            if (zqdan[i].optionid == dtdan[j]) {
              isd++;
              continue;
            }
          }
        }
        if(dtdan.length == zqdan.length && isd==zqdan.length )
        {
          this.isdd = true;
          item.isdc = true;
        }
        else
        {
          this.isdd = false;
          item.isdc = false;
        }
      }
      this.isda=true
    },
    ctrk(examInfoid){
      this.$ajax.get('/student/lianxi/studentctrk/'+examInfoid).then(response => {
        Notify({ type: 'success', message: response.msg});
      });
    }
  }
}
</script>
<style lang="scss">
.fill-in-blank{
  .items{
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    .item{
      display: flex;
      flex-wrap: wrap;
      input{
        border: none;
        border-bottom: 1px solid rgb(204, 203, 203);
        width: 3.75rem;
        text-align: center;
        padding: 0 .625rem;
        margin: 0 .3125rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/studentpage/lianxicomm/fillIn.vue